module.exports = __webpack_public_path__ + "img/record1.c5d9e6fe.png";